import bcrypt from 'bcryptjs';

const REGISTRATION_PASSWORD_KEY = "registrationPassword";

export const hashPassword = async (password) => {
  if (!password) return "";
  const salt = await bcrypt.genSalt(10);
  return await bcrypt.hash(password, salt);
};

export const commonPasswords = [
  "Password123!",
  "Admin@1234",
  "Welcome@123",
  "Qwerty@123",
  "P@ssw0rd123",
  "Iloveyou123!",
  "Abc123!@#",
  "Test@1234",
  "User@2024",
  "Login@123",
  "Password1!",
  "Qwerty123!",
  "Welcome1@",
  "Admin123$",
  "Monkey123!#",
  "LetMeIn1!#",
  "1234Abcd!",
  "Iloveyou1#"
];

export const storeRegistrationPassword = (password) => {
  sessionStorage.setItem(REGISTRATION_PASSWORD_KEY, password);
};

export const getStoredRegistrationPassword = () =>
  sessionStorage.getItem(REGISTRATION_PASSWORD_KEY) || "";

export const clearStoredRegistrationPassword = () => {
  sessionStorage.removeItem(REGISTRATION_PASSWORD_KEY);
};
